// extracted by mini-css-extract-plugin
module.exports = {"page":"DomainOrder_page_2g13F","item":"DomainOrder_item_1-lGV","btn_actions":"DomainOrder_btn_actions_3brg5"};